import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { CryptoService } from '../crypto.service';
import { CaesarComponent } from '../caesar/caesar.component';
import { InputFieldComponent } from '../input-field/input-field.component';
import { SkytaleComponent } from '../skytale/skytale.component';
import { CryptoView } from '../crypto-view';
import { MonoalphabeticComponent } from '../monoalphabetic/monoalphabetic.component';
import { VignereComponent } from '../vignere/vignere.component';

@Component({
  selector: 'app-define-key',
  templateUrl: './define-key.component.html',
  styleUrls: ['../topic-style.css', './define-key.component.css']
})
export class DefineKeyComponent extends GeneralExerciseComponent {

  @ViewChild('caesar', {static: true})
  private caesar: CaesarComponent;

  @ViewChild('skytale', {static: true})
  private skytale: SkytaleComponent;

  @ViewChild('monoalphabetic', {static: true})
  private monoalphabetic: MonoalphabeticComponent;

  @ViewChild('vignere', {static: true})
  private vignere: VignereComponent;

  private view: CryptoView;

  @ViewChild('inputField', {static: true})
  private inputField: InputFieldComponent;

  @ViewChild('inputFieldDecode', {static: true})
  private inputFieldDecode: InputFieldComponent;

  plainText: string;
  cipherText: string;
  method: string;
  keyP: any;
  modus: string;

  dPlainText: string[];
  dCipherText: string[];

  caretPos: number = 0;
  positionLetter: string;

  decoded: boolean = false;
  keySet: boolean = false;

  errors: number[] = [];

  constructor(activatedRoute: ActivatedRoute, topicService: TopicService, messageService: MessageService, protected cryptoService: CryptoService) {
    super(activatedRoute, topicService, messageService);
  }

  setTypeSpecificsFromConfiguration() {
    this.decoded = false;
    this.plainText = this.configuration.typespecifics.text;
    this.dPlainText = this.plainText.split("");
    this.cipherText = ""; //this.cryptoService.encode(this.method, this.keyP, this.plainText.replace(/[A-z]/gi, "-"));
    this.method = this.configuration.typespecifics.method;
    switch (this.method) {
      case "caesar": this.view = this.caesar; break;
      case "skytale": this.view = this.skytale; break;
      case "monoalphabetic": this.view = this.monoalphabetic; break;
      case "vignere": this.view = this.vignere; break;
    }
    this.modus = this.configuration.typespecifics.modus;

    this.keySet = false;
    this.keyP = undefined;
    this.caretPos = 0;
    while (this.cipherText.charAt(this.caretPos) === " ") {
      this.caretPos++;
    }

    this.onEmitDecode(this.caretPos);
    if (this.view) {
      this.view.resetmapping();
    }
  }

  setTypeSpecificsFromState() {
    if (this.state.typespecifics) {
      if (this.state.typespecifics.keySet) {
        this.keySet = this.state.typespecifics.keySet;
      }

      if (this.state.typespecifics.keyP) {
        this.keyP = this.state.typespecifics.keyP;
      }

      if (this.state.typespecifics.decoded) {
        this.decoded = this.state.typespecifics.decoded;
      }

      if (this.state.typespecifics.cipherText) {
        this.cipherText = this.state.typespecifics.cipherText;
        this.dCipherText = this.cipherText.split("");
      }
      if (this.decoded) {
        this.positionLetter = this.cipherText.charAt(0);
      }
      if (this.decoded && this.state.typespecifics.plainText) {
        this.plainText = this.state.typespecifics.plainText;
      }
      if (this.state.typespecifics.mapping) {
        this.view.setmapping(this.state.typespecific.mapping);
      }
    }
  }

  computeState() {
    this.state.typespecifics = {};
    this.state.typespecifics.keySet = this.keySet;
    this.state.typespecifics.keyP = this.keyP;

    if (this.keySet) {
      if (!this.decoded) {
        this.cipherText = this.inputField.text;
      }
      this.state.typespecifics.cipherText = this.cipherText;
    }

    this.state.typespecifics.decoded = this.decoded;
    if (this.decoded) {
      if (this.inputFieldDecode) {
        this.plainText = this.inputFieldDecode.text;
      }
      this.state.typespecifics.plainText = this.plainText;
    }
    console.log(this.view);
    this.state.typespecific.mapping = this.view.getMapping();
  }

  evaluate(): number[] {
    if (!this.keySet) {
      return [0, 1];
    }
    if (this.decoded) {
      return [this.state.evaluate, this.state.maxPoints];
    }
    let solution = this.cryptoService.encode(this.method, this.keyP, this.plainText);
    this.cipherText = this.inputField.text;
    let errors = solution.split("").map((v, i) => [v, this.cipherText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
    let result = [(this.plainText.length - errors.length) / 20, this.plainText.length / 20];
    if (this.modus == 'highlight') {
      result = result.map(v => v / 2);
    }
    if (this.method == 'vignere') {
      result = result.map(v => v * 1.5);
    }
    return result;
  }


  checkSolution() {
    if (!this.decoded) {
      this.checkEncryption();
    } else {
      let solution = this.cryptoService.decode(this.method, this.keyP, this.cipherText);
      this.plainText = this.inputFieldDecode.text;
      this.errors = solution.split("").map((v, i) => [v, this.plainText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
      if (this.method == "skytale") {
        this.errors = this.errors.map((v, i) => Math.floor(v % (Math.floor(this.plainText.length / this.keyP))) * (this.keyP) + Math.floor(v / ((Math.floor(this.plainText.length / this.keyP)))));
      }
      if (this.errors.length > 0) {
        this.messageService.addAlertWithTimeout(this.get("notCorrectlyDecoded"), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("correctlyDecoded"), "success", 10000);
        this.solved = true;
        this.state.solved = true;
        this.saveState();
      }
    }
  }

  /** check if the encryption part is correct */
  checkEncryption() {
    this.cipherText = this.inputField.text;
    if (!this.isExamQuestion()) {
      let solution = this.cryptoService.encode(this.method, this.keyP, this.plainText);
      this.cipherText = this.inputField.text;
      this.errors = solution.split("").map((v, i) => [v, this.cipherText.charAt(i), i]).filter(v => v[0] != v[1]).map(v => +v[2]);
      if (this.method == "skytale") {
        this.errors = this.errors.map((v, i) => Math.floor(v % this.keyP) * (Math.ceil(this.plainText.length / this.keyP)) + Math.floor(v / this.keyP));
      }
      if (this.errors.length > 0) {
        this.messageService.addAlertWithTimeout(this.get("notCorrectlyEncoded"), "danger", 10000);
      } else {
        this.messageService.addAlertWithTimeout(this.get("correctlyEncoded"), "success", 10000);
        this.decoded = true;
        this.plainText = this.cryptoService.decode(this.method, this.keyP, this.cipherText).replace(/[A-z0-9]/gi, "-");
        this.inputField.text = this.plainText;
        this.caretPos = 0;
        this.onEmitDecode(this.caretPos);
        this.dCipherText = this.cipherText.split("");
        this.saveState();
      }
    } else {
      this.decoded = true;
      this.plainText = this.cryptoService.decode(this.method, this.keyP, this.cipherText).replace(/[A-z0-9]/gi, "-");
      this.inputField.text = this.plainText;
      this.caretPos = 0;
      this.onEmitDecode(this.caretPos);
      this.dCipherText = this.cipherText.split("");
      this.saveState();
    }
  }



  /** if the ciphertext changes, compute the highlighted position */
  onEmitEncode(event) {
    this.caretPos = event;
    this.positionLetter = this.plainText.charAt(this.caretPos);
    if (this.method == "skytale") {
      this.positionLetter = this.caretPos.toString();
      this.caretPos = Math.floor(event % this.keyP) * (Math.ceil(this.plainText.length / this.keyP)) + Math.floor(event / this.keyP);
      while (this.plainText.charAt(this.caretPos) === " ") {
        this.caretPos--;
      }
    }
    if (this.method == "vignere") {
      this.positionLetter = this.caretPos.toString();
    }

  }

  /** if the plain text changes, compute the highlighted positions */
  onEmitDecode(event) {
    this.caretPos = event;
    this.positionLetter = this.cipherText.charAt(this.caretPos);
    if (this.method == "skytale") {
      this.positionLetter = this.caretPos.toString();
      this.caretPos = Math.floor(event % (Math.floor(this.plainText.length / this.keyP))) * (this.keyP) + Math.floor(event / ((Math.floor(this.plainText.length / this.keyP))));
      while (this.plainText.charAt(this.caretPos) === " ") {
        this.caretPos--;
      }
    }
    if (this.method == "vignere") {
      this.positionLetter = this.caretPos.toString();
    }
  }

  /** when the key changes, check for valid key and initialize the encoding task */
  onKeySet() {
    if (this.method == "monoalphabetic") {
      let mapping = this.view.getMapping();
      if (!mapping) {
        this.messageService.addAlertWithTimeout(this.get("KeyIsNotMono"), "danger", 10000);
        return;
      }
      if (mapping.length != 26) {
        this.messageService.addAlertWithTimeout(this.get("KeyIsNotMono"), "danger", 10000);
        return;
      }
      let keyP: string = mapping;
      keyP = keyP.split("").sort().join("");
      if (keyP != "ABCDEFGHIJKLMNOPQRSTUVWXYZ") {
        this.messageService.addAlertWithTimeout(this.get("KeyIsNotMono"), "danger", 10000);
        return;
      }
    }
    this.keySet = true;
    this.cipherText = this.cryptoService.encode(this.method, this.keyP, this.plainText).replace(/[A-z0-9]/gi, "-");;
    this.caretPos = 0;
    this.onEmitEncode(this.caretPos);
  }

  /** generate a monoalphabetic key */
  generateKey() {
    this.keyP = "";
    let chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("");
    while (chars.length > 0) {
      let i = Math.floor(Math.random() * chars.length);
      this.keyP = this.keyP.concat(chars[i]);
      chars.splice(i, 1);
    }
  }

  /** return the correct method description */
  getMethodDescription() {
    switch (this.method) {
      case "caesar": return this.get("useCaesar");
      case "polybius": return this.get("usePolybius");
      case "skytale": return this.get("useSkytale");
      case "monoalphabetic": return this.get("useMonoalphabetic");
      case "vignere": return this.get("useMask");
      case "pigpen": return this.get("usePigpen");
      case "atbash": return this.get("useAtbash");
      case "morse": return this.get("useMorse");
    }

  }

}
